import React from 'react';

interface Session {
  startDateTime: string;
}

interface Props {
  sessions: Session[];
}

const SessionDateBadge: React.FC<Props> = ({ sessions }) => {
  if (!sessions || sessions.length === 0) return null;

  const now = new Date();
  const futureSession = sessions.find(
    (s) => new Date(s.startDateTime) > now
  );

  const sessionToShow = futureSession || sessions[sessions.length - 1];

  const sessionDate = new Date(sessionToShow.startDateTime);

  return (
    <div className="absolute top-2 left-2 bg-white text-center px-2 py-1 rounded-md">
      <span className="block text-[9.5px] font-bold text-primaryBlueText">
        {sessionDate.getDate()}
      </span>
      <span className="block text-[9.5px] text-primaryBlueText -my-1">
        {sessionDate.toLocaleString('en-US', { month: 'short' })}
      </span>
      <span className="block text-[9.5px] text-primaryBlueText mt-[0.5px]">
        {sessionDate.getFullYear()}
      </span>
    </div>
  );
};

export default SessionDateBadge;
